import ImageButton from 'components/Theme/Elements/ImageButton';
import YouTubeIcon from 'assets/discovery/youtube-icon.png';

function YouTubeIconButton() {
  return <ImageButton imageSrc={YouTubeIcon} height={45} width={45} />;
}

export default YouTubeIconButton;
